// extracted by mini-css-extract-plugin
export var change = "_3s-1";
export var changeList = "_3s-0";
export var changePath = "_3s-2";
export var diffArrow = "_3s-5";
export var diffRow = "_3s-3";
export var diffValue = "_3s-4";
export var error = "_3s-8";
export var notice = "_3s-9";
export var result = "_3s-6";
export var success = "_3s-7";